<template>
    <div>
      <!--图像裁剪-->
      <div class="Orderinfordiv" id="updateIMage_goods">
        <imageCJ ref="child_IMAGE" @fatherMethod="fatherMethod" width="1" height="1" :img_date="img_date" div_name="updateIMage_goods"></imageCJ>
      </div>
      <!--商品的所有详情-->
      <div class="Goodsinfordiv" id="Goodsinfor_G">
        <div class="GoodsinforForm">
          <!--头部标签-->
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              {{goodsinfors.name+"，"}}详细信息
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close_goodsinfor()">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <!--主体结构-->
          <div style="overflow: hidden;">
            <!--商品信息区域-->
            <div style="width: 98%;margin: 0 auto;height: 375px;margin-top: 4px;">
              <table width="100%" border="0" cellspacing="8" cellpadding="8" style="text-align: center;">
                <tr>
                    <td width="15%"><div style="text-align: right;">商品编号：</div></td>
                    <td width="35%"><div style="text-align: left;">{{goodsinfors.id}}</div></td>
                    <td rowspan="5">
                      <div style="width: 200px;height: 200px;margin: 0 auto;">
                        <div class="flex" style="width: 100%;height: 100%;font-size: 25px;" v-if="disabled">
                          <img :src="goods_img" alt="" width="200px" height="200px">
                        </div>
                        <div class="flex" style="width: 100%;height: 100%;font-size: 25px;" v-else>
                          <el-upload
                            ref="upload_img_photo_goods"
                            class="avatar-uploader"
                            action="/api/updateGoods_goodsimg"
                            :data="goodsinfors"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess_goods"
                            :before-upload="beforeAvatarUpload"
                            :auto-upload="false"
                            :on-change="handleChange_goods"
                            :headers="myHeaders">
                            <img :src="goods_img" alt="" width="200px" height="200px" style="margin-top: 1px;">
                          </el-upload>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div style="text-align: right;">商品名称：</div></td>
                    <td><div style="text-align: left;"><el-input v-model="goodsinfors.name" size="mini" :disabled="disabled" placeholder="商品名称"></el-input></div></td>
                  </tr>
                  <tr>
                    <td><div style="text-align: right;">商品价值：</div></td>
                    <td><div style="text-align: left;"><el-input v-model="goodsinfors.money" size="mini" :disabled="disabled" placeholder="商品价值"><template slot="append">￥</template></el-input></div></td>
                  </tr>
                  <tr>
                    <td><div style="text-align: right;">商品库存：</div></td>
                    <td><div style="text-align: left;"><el-input-number v-model="goodsinfors.number" size="mini" :disabled="disabled" :min="0" :max="999" label="库存" style="width: 100%;"></el-input-number></div></td>
                  </tr>
                  <tr>
                    <td><div style="text-align: right;">商品类别：</div></td>
                    <td><div style="text-align: left;">
                      <el-select v-model="goodsinfors.category_id" size="mini" :disabled="disabled" placeholder="请选择商品类别" style="width: 100%;">
                        <el-option
                          v-for="item in options1"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div></td>
                  </tr>
                  <tr>
                    <td><div style="text-align: right;">商品状态：</div></td>
                    <td><div style="text-align: left;">
                      <span style="color: green;" v-if="goodsinfors.type=='0'">
                        出售中
                      </span>
                      <span style="color: red;" v-else>
                        已下架
                      </span>
                    </div></td>
                    <td>点击图片进行图片更改！</td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div style="text-align: right;margin-right: 80px;" v-if="disabled"><el-button type="danger" size="small" @click="close_goodsinfor()">关闭</el-button></div>
                      <div style="text-align: right;margin-right: 80px;" v-else><el-button type="danger" size="small" @click="updateGoods(0)">取消修改</el-button></div>
                    </td>
                    <td>
                      <div style="text-align: left;margin-left: 80px;" v-if="disabled"><el-button type="primary" size="small" @click="updateGoods(1)">修改</el-button></div>
                      <div style="text-align: left;margin-left: 80px;" v-else><el-button type="primary" size="small" @click='submit_goodsinfor()'>保存</el-button></div>
                    </td>
                  </tr>
              </table>
            </div>
            <!--详细信息区域-->
            <!--添加区域-->
            <div style="width: 98%;height: 426px;margin: 0 auto;">
              <mavon-editor style="height: 98%;" ref=md v-model="content" @imgAdd="imgAdd" @imgDel="imgDel" @save="saveDoc"></mavon-editor>
            </div>
          </div>

        </div>
      </div>
      <!--通知详情单-->
      <div class="Orderinfordiv" id="Noticeinformains_G">
        <div class="OrderinforForm">
          <!--头部标签-->
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              评价信息（{{goodsEvaluate.pageTotal}}）
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="closeInformation()">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <!--主体结构-->
          <div class="playlistbox_botton" v-loading="loadingxx" v-if="Evaluate.length>0">
            <div style="width: 850px;min-height: 550px;margin: 0 auto;margin-top: 15px;">
              <div style="width: 850px;min-height: 70px;" v-for="url in Evaluate" :key="url.id">
                <div style="width: 850px;overflow: hidden;" class="flex"><!--文字图片与评论人-->
                  <div style="width: 750px;float: left;"><!--左边-->
                    <div style="margin: 5px;font-size: 15px;width: 840px;">
                      <p>{{url.content}}</p>
                    </div>
                    <div style="width: 830px;height: 50px;overflow: hidden;margin: 10px;" v-if="url.img.length>0">
                      <div style="float: left;overflow: hidden;line-height: 50px;">
                        <el-image
                          v-for="urls in url.img" :key="urls.id"
                          style="height: 50px;width: 50px;margin-right: 10px;"
                          :src="urls.img"
                          :preview-src-list="transformation_data(urls.img)">
                        </el-image>
                      </div>
                    </div>
                  </div>
                  <div style="width: 100px;float: left;height: 100%;"><!--右边-->
                    <div style="overflow: hidden;font-size: 15px;color: #AAAAAA;">
                      {{url.u_name}}
                    </div>
                  </div>
                </div>
                <div style="margin: 5px;color: #ccc;font-size: 14px;">
                  {{url.time*1 | formatDate}}
                </div>
                <div>
                  <hr style="border:0.05rem solid #ccc;"><!--界限分割-->
                </div>
              </div>
            </div>
            <div style="text-align: center;margin-top: 20px;margin-bottom: 10px;"><!--页码-->
              <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="goodsEvaluate.pageNum"
                 :page-size="goodsEvaluate.pageSize" layout="prev, pager, next" :total="goodsEvaluate.pageTotal">
              </el-pagination>
            </div>
          </div>

          <div class="playlistbox_botton" v-loading="loadingxx" v-else>
            <div class="flex" style="width: 100%;min-height: 550px;">
              没有评价信息！！！
            </div>
          </div>

        </div>
      </div>
      <!--添加打折信息-->
      <div class="logindivD" id="AddFormD_G">
        <div class="loginFormD">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              添加打折信息
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="closediscount">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddDiscountForm" ref="AddDiscountForm" style="margin-top: 20px;">
              <el-form-item prop="g_name">
                <div style="width: 300px;text-align: left;">商品名:{{AddDiscountForm.g_name}}</div>
              </el-form-item>
              <el-form-item prop="name">
                <el-input type="text" v-model="AddDiscountForm.name" disabled placeholder="打折名称"></el-input>
              </el-form-item>
              <el-form-item prop="discount">
                <el-input-number v-model="AddDiscountForm.discount" @change="getdiscount_name()" :precision="2" style="width: 100%;" :step="0.05" :max="1" :min="0.1"></el-input-number>
              </el-form-item>
              <el-form-item prop="start_time">
                <el-date-picker v-model="AddDiscountForm.start_time" type="datetime" style="width: 100%;" value-format="timestamp" placeholder="起始日期"></el-date-picker>
              </el-form-item>
              <el-form-item prop="end_time">
                <el-date-picker v-model="AddDiscountForm.end_time" type="datetime" style="width: 100%;" value-format="timestamp" placeholder="结束日期"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <span>
                  <el-button type="danger" @click="deleteDiscount" v-if="AddDiscountForm.g_discount!=1">删除当前折扣</el-button>
                  <el-button type="primary" style="width: 100px;" @click="Add_ORDiscount">保存</el-button>
                </span>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <!--添加商品信息-->
      <div class="logindiv" id="AddForm1_G">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              添加新商品
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 750px;margin: 0 auto;overflow: hidden;">
            <div style="width: 100%;">
              <div style="float: left;width: 50%;">
                <el-form :model="AddForm" ref="AddForm" style="margin-top: 30px;">
                  <el-form-item prop="name">
                    <el-input type="text" v-model="AddForm.name" placeholder="商品名称"></el-input>
                  </el-form-item>
                  <el-form-item prop="name">
                    <el-select v-model="AddForm.category_id" placeholder="请选择商品类别" style="width: 100%;">
                      <el-option
                        v-for="item in options1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="money">
                    <el-input type="text" v-model="AddForm.money" placeholder="商品价格"></el-input>
                  </el-form-item>
                  <el-form-item prop="money">
                    <el-button type="primary" style="width: 50%;" @click="AddGoods()">保存</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div style="float: left;width: 50%;">
                <div style="margin-top: 30px;">
                  <div style="width: 202px;height: 202px;border: 0.05rem solid #aaa;margin: 0 auto;">
                    <el-upload
                      class="avatar-uploader"
                      ref="upload_photo"
                      action="/api/AddGoods"
                      :data="AddForm"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      :auto-upload="false"
                      :on-change="changephoto"
                      :on-remove="handleRemove"
                      :headers="myHeaders"
                      :limit="1">
                      <img v-if="imageUrl" :src="imageUrl" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <br>
                    点击框内添加/更改图片
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item>
                <el-button type="primary" class="btn" @click="Addwindow()"><i class="el-icon-circle-plus-outline"></i>添加商品</el-button>
              </el-form-item>
              <el-form-item label="类别">
                <el-select v-model="formInline.category_id" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="名称">
                <el-input v-model="formInline.name" placeholder="名称" class="elInput"></el-input>
              </el-form-item>
              <el-form-item label="价格">
                <el-input v-model="formInline.startmoney" class="elInput" placeholder="价格范围开始"></el-input>
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model="formInline.endmoney" class="elInput" placeholder="价格范围结束"></el-input>
              </el-form-item>
              <el-form-item label="商品状态">
                <el-select v-model="formInline.type" class="elInput" style="width: 120px;">
                  <el-option label="在售" value="0"></el-option>
                  <el-option label="下架" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="140"></el-table-column>
              <el-table-column align="center" label="商品大图" prop="admin_name" width="150">
                <template slot-scope="scope">
                  <img :src="scope.row.img_url" alt="" width="100px" height="100px">
                </template>
              </el-table-column>
              <el-table-column align="center" label="商品名" prop="name" width="200"></el-table-column>
              <el-table-column align="center" label="商品分类" prop="category_name" width="100"></el-table-column>
              <el-table-column align="center" label="原价" prop="money" width="100">
                <template slot-scope="scope">
                  <span>{{getFmoney(scope.row.money*1,1)}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="打折力度" prop="discount" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.discount*1==1">无折扣</span>
                  <span v-else>{{scope.row.discount*10}}折</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="现价" prop="title" width="100">
                <template slot-scope="scope">
                  <span>{{getFmoney(scope.row.money*1,scope.row.discount*1)}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="库存" prop="number" width="100"></el-table-column>
              <el-table-column align="center" label="销量" prop="volume" width="100"></el-table-column>
              <el-table-column align="center" label="修改时间" prop="time" width="200">
                <template slot-scope="scope">
                  <span>{{scope.row.retime*1 | formatDate}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="修改人" prop="admin_name" width="150"></el-table-column>
              <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                  <span>
                    <el-button size="small" type="primary" @click="open_goodsinfor(scope.row)">详情情况</el-button>
                  </span>
                  <span>
                    <el-button size="small" type="primary" @click="getEvaluate(scope.row)">评价情况</el-button>
                  </span>
                  <br><br>
                  <span>
                    <el-button size="small" type="primary" @click="opendiscount(scope.row)">打折设置</el-button>
                  </span>
                  <span v-if="scope.row.type!='1'">
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="你确定要下架此商品么吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button type="danger" size="small" slot="reference">下架</el-button>
                    </el-popconfirm>
                  </span>
                  <span v-else>
                    <el-button type="danger" size="small" slot="reference" @click="NOdeletes(scope.$index, scope.row)">重新上架</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import imageCJ from '@/img_update/images_UP.vue'//头像裁剪
  import {commonAPI} from '@/api/commonAPI'
  import PicZoom from 'vue-piczoom'
  import axios from 'axios' //引入axios
  let Atoken=sessionStorage.getItem("Atoken")
  export default {
    components: {
      'imageCJ': imageCJ,
    },
    data() {
      return {
        //
        img_date:null,
        newfile:null,
        //
        content:'',
        //商品的详细信息
        allgoodsinfor:'',
        AddForm_goodsinfor:{
          g_id:'',
          admin_id:'',
          content:'',
          html:''
        },
        fileData: '',  // 文件上传数据（多文件合一）
        fileList: [],   // upload多文件数组
        //修改数据比对
        pddata_goods:{
          id:'',
          name:"",
          money:'0',
          number:0,
          category_id:'',
          type:'',
        },
        goodsinfors:{
          id:'',
          name:"",
          money:'0',
          number:0,
          category_id:'',
          type:'',
        },
        loading_goods:false,
        //商品详情图片
        goods_img:'',
        //判定是否可以修改信息
        disabled:true,
        loadingxx:false,
        //评论信息
        Evaluate:'',
        //评论信息
        goodsEvaluate:{
          g_id:'',
          pageNum:1,
          pageSize:4,
          pageTotal:0,
        },
        //添加打折信息
        AddDiscountForm:{
          g_id:'',
          g_name:'',
          name:'无折扣',
          start_time:'',
          end_time:'',
          discount:1,
          g_discount:'',
        },
        myHeaders: {
          Atoken:Atoken,
        },
        imageUrl:'',
        data:'',
        tableData: [],
        loading: false,
        formInline: {
          category_id:'',
          startmoney:'',
          name:'',
          type:'0',
          endmoney:'',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          admin_id:'',
          name:'',
          photo:'',
          money:'',
          category_id:'',
        },
        options:[],
        options1:[],
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          }
        },
    //页面开启时执行
    mounted(){
      this.getData();
      this.getGoodslist_category();
    },
    methods: {
      //
      openInformation(){
        document.getElementById('updateIMage_goods').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      //
      fatherMethod(data){
        this.newfile=data;
        if(this.imageUrl==null||this.imageUrl==""||this.imageUrl=="null"){
          this.$refs['upload_img_photo_goods'].clearFiles();//清除文件
          this.$refs['upload_img_photo_goods'].handleStart(data);//选择文件后的赋值方法
          this.$refs.upload_img_photo_goods.submit();
        }else{
          this.$refs['upload_photo'].clearFiles();//清除文件
          this.$refs['upload_photo'].handleStart(data);//选择文件后的赋值方法
          this.newfile=null;
        }
        //console.log("123"+data);
      },
      //改变图片框状态
      //查看是否出错
      handleChange_goods(file, fileList) {
          this.goodsinfors.admin_id=this.$store.state.a_id;
          if(this.newfile!==null&&file.name==this.newfile.name){
            return false;
          }else{
            this.img_date=file;
            this.openInformation();
          }
      },
      //商品图片信息修改
      handleAvatarSuccess_goods(res, file) {
        if(this.response.response(res)){
          this.goods_img = URL.createObjectURL(file.raw);
          this.getData();
        }
      },
      //详细信息的获取
      getallgoodsinfor(){
        commonAPI('queryGoodsInfor', this.goodsinfors).then(res => {
          this.allgoodsinfor=res.data.data.rows[0];
          this.loading_goods = false;
          this.content=this.allgoodsinfor.content;
        })
      },
      //查看图片集是否有不符合规定的图片
      submitUpload() {
        if(this.AddForm_goodsinfor.g_id==''||this.AddForm_goodsinfor.admin_id==''){
          this.$message.error('系统错误，请重试!');
          return false;
        }
        if(this.fileList.length<=0){
          this.$message.error('请选择文件！');
          return false;
        }
        this.$refs.upload.submit();
      },
      beforeAvatarUpload_goodsinfor(file) {
        let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png'];
        const isImage = types.includes(file.type);
        const isLtSize = file.size / 1024 / 1024 < 5;
        if (!isImage) {
        this.$message.error('上传图片只能是 JPG、GIF、BMP、PNG 格式!');
        }
        if (!isLtSize) {
        this.$message.error('上传图片大小不能超过 5MB!');
        }
        return isImage && isLtSize;
      },
      //监控上传文件列表
      handleChange_goodsinfor(file, fileList) {
          let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
          if (existFile) {
              this.$message.error('当前文件已经存在!');
              fileList.pop();
          }
          this.fileList = fileList;
      },
      //添加详细信息文件列
      // 上传文件
      handleRemove_goodsinfor(file, fileList) {
        this.fileList = fileList;
      },
      handlePreview_goodsinfor(file) {
        console.log(file);
      },
      //提交商品修改内容
      submit_goodsinfor(){
        if(this.goodsinfors.id==''||this.goodsinfors.name==''||this.goodsinfors.money==''||this.goodsinfors.number==''||this.goodsinfors.category_id==''){
          this.$message.warning('请填写完整的信息！！');
          return false
        }
        let regPos = /^\d+(\.\d+)?$/; //非负浮点数
        if(!regPos.test(this.goodsinfors.money)){
          this.$message.warning('价钱只能填写数字！！');
          return false
        }
        if(this.goodsinfors.id==this.pddata_goods.id&&this.goodsinfors.name==this.pddata_goods.name&&this.goodsinfors.money==this.pddata_goods.money&&this.goodsinfors.number==this.pddata_goods.number&&this.goodsinfors.category_id==this.pddata_goods.category_id){
          this.updateGoods(0);
          this.$message.warning('没有做任何修改！！');
          return false
        }
        let date = new Date().getTime();
        this.goodsinfors.admin_id=this.$store.state.a_id;
        this.goodsinfors.retime=date;
        commonAPI('updateGoods',this.goodsinfors).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
            this.updateGoods(0);
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //进行修改商品信息数据
      updateGoods(data){
        if(data==1){
          this.disabled=false;
        }else{
          this.disabled=true;
        }
      },
      //关闭商品详情
      close_goodsinfor(){
        //
        this.AddForm_goodsinfor.g_id='';
        this.AddForm_goodsinfor.admin_id='';
        this.content='';
        //
        this.pddata_goods.id=''
        this.pddata_goods.name=''
        this.pddata_goods.money=''
        this.pddata_goods.number=''
        this.pddata_goods.type=''
        this.pddata_goods.category_id=''
        //
        this.goodsinfors.id=''
        this.goodsinfors.name=''
        this.goodsinfors.money=''
        this.goodsinfors.number=''
        this.goodsinfors.type=''
        this.goodsinfors.category_id=''
        this.goods_img=''
        this.disabled=true;
        document.getElementById('Goodsinfor_G').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      //打开商品详情
      open_goodsinfor(data){
        this.loading_goods=true
        //
        this.AddForm_goodsinfor.g_id=data.id
        this.AddForm_goodsinfor.admin_id=this.$store.state.a_id;
        //
        this.pddata_goods.id=data.id
        this.pddata_goods.name=data.name
        this.pddata_goods.money=data.money
        this.pddata_goods.number=data.number
        this.pddata_goods.type=data.type
        this.pddata_goods.category_id=data.category_id
        //
        this.goodsinfors.id=data.id
        this.goodsinfors.name=data.name
        this.goodsinfors.money=data.money
        this.goodsinfors.number=data.number
        this.goodsinfors.type=data.type
        this.goodsinfors.category_id=data.category_id
        this.goods_img=data.img_url
        document.getElementById('Goodsinfor_G').style.display='block';
        document.getElementById('zhedang').style.display='block';
        this.getallgoodsinfor();
      },
      //
      closeInformation(){
        this.Evaluate='';
        document.getElementById('Noticeinformains_G').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      //获取评论
      getEvaluate(data){
        document.getElementById('Noticeinformains_G').style.display='block';
        document.getElementById('zhedang').style.display='block';
        this.loadingxx=true;
        if(data!=1){
          this.goodsEvaluate.g_id=data.id;
        }
        commonAPI('queryEvaluatelist', this.goodsEvaluate).then(res => {
            this.Evaluate=res.data.data.rows;
            this.goodsEvaluate.pageTotal=res.data.data.total;
            this.loadingxx=false;
        })
      },
      //图片数组转换
      transformation_data(data){
        let arr1=[];
        arr1.push(data);
        return arr1;
      },
      //评论区域的信息
      handleCurrentChange1(val) {
        //console.log(`当前页: ${val}`);
        this.goodsEvaluate.pageNum=val;
        this.getEvaluate(1);
      },
      handleSizeChange1(val) {
        //console.log(`每页 ${val} 条`);
        this.goodsEvaluate.pageSize=val;
        this.goodsEvaluate.pageNum=1;
        this.getEvaluate(1);
      },
      //删除折扣信息
      deleteDiscount(){
        this.AddDiscountForm.admin_id=this.$store.state.a_id;
        commonAPI('deleteDiscount',this.AddDiscountForm).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
            this.closediscount();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //添加折扣信息
      Add_ORDiscount(){
        if(this.AddDiscountForm.discount==1){
          this.$message.warning('无折扣不用提交！！');
          return false;
        }
        if(this.AddDiscountForm.start_time==''||this.AddDiscountForm.end_time==''){
          this.$message.warning('请填写完整的信息！！');
          return false;
        }
        this.AddDiscountForm.admin_id=this.$store.state.a_id;
        commonAPI('Add_ORDiscount',this.AddDiscountForm).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
            this.closediscount();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //打开折扣页面
      opendiscount(data){
        this.AddDiscountForm.g_id=data.id;
        this.AddDiscountForm.g_name=data.name;
        this.AddDiscountForm.g_discount=data.discount;
        document.getElementById('AddFormD_G').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      //关闭折扣页面
      closediscount(){
        this.AddDiscountForm.g_id='';
        this.AddDiscountForm.g_name='';
        this.AddDiscountForm.discount=1;
        this.AddDiscountForm.name='无折扣';
        this.AddDiscountForm.start_time='';
        this.AddDiscountForm.end_time='';
        document.getElementById('AddFormD_G').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      //获取打折名称
      getdiscount_name(){
        this.AddDiscountForm.name=this.AddDiscountForm.discount*10+"折";
        if(this.AddDiscountForm.discount==1){
          this.AddDiscountForm.name="无折扣";
        }
      },
      //价钱浮动计算方法
      getFmoney(money,discount){
        let m=0,s1=money.toString(),s2=discount.toString(),sum=0;
        try{m+=s1.split(".")[1].length}catch(e){}
        try{m+=s2.split(".")[1].length}catch(e){}
        sum=Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
        return sum.toFixed(2);
      },
      //重置查询
      resetting() {
        this.formInline.category_id = '';
        this.formInline.name = '';
        this.formInline.startmoney = '';
        this.formInline.endmoney = '';
        this.formInline.type = '0';
        this.getData();
      },
      //添加内容
      AddGoods(){
        this.AddForm.admin_id=this.$store.state.a_id;
        if(this.AddForm.name==''||this.AddForm.money==''||this.AddForm.category_id==''||this.imageUrl==''){
          this.$notify({
          title: '提示',
          message: '请填写完整数据',
          position: 'bottom-right',
          type: 'error'
          });
          return false;
        }
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        if(!regPos.test(this.AddForm.money)){
          this.$notify({
          title: '提示',
          message: '价钱只能填写数字',
          position: 'bottom-right',
          type: 'error'
          });
          return false
        }
        this.$refs.upload_photo.submit();
      },
      Addwindow(row){
        //this.AddForm.message_id=row.id;
        document.getElementById('AddForm1_G').style.display='block';
        document.getElementById('zhedang').style.display='block';
        //console.log('打开窗口');
      },
      //删除下架
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        row.img_url='';
        row.type='1';
        //console.log(index, row);
        commonAPI('deleteGoods',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //上架
      NOdeletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        row.type='0';
        //console.log(index, row);
        commonAPI('deleteGoods',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //查看商品类别列表
      getGoodslist_category(){
        commonAPI('queryCategoryList', "1").then(res => {
          let categorylist=res.data.data.list;
          let list=[];
          list.push({value:'',label:'全部'})
          for(let i = 0; i < categorylist.length;i++){
            list.push(categorylist[i])
          }
          this.options=list;
          this.options1=categorylist;
        })
      },
      //查询
      getData() {
        this.loading = true;
        let time =new Date().getTime();
        this.formInline.nowTime=time;
        commonAPI('AqueryGoods',this.formInline).then(res => {
          this.loading = false;
          this.tableData = res.data.data.rows;
          this.pageTotal=res.data.data.total;
          //console.log(res.data.rows);
        })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      close(){
        this.AddForm.name='';
        this.AddForm.money='';
        this.imageUrl='';
        this.AddForm.category_id='';
        this.$refs['upload_photo'].clearFiles();//清除文件
        document.getElementById('AddForm1_G').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      //修改图片成功
      handleAvatarSuccess(res, file) {
        if(this.response.response_login(res)){
          this.getData();
          this.close();
        }
      },
      //删除当前文件
      handleRemove(file, fileList) {
        //console.log(file, fileList);
        this.imageUrl = '';
      },
      //改变图片框状态
      changephoto(file, fileList){
        this.imageUrl = URL.createObjectURL(file.raw);
        if(this.newfile!==null&&file.name==this.newfile.name){
          return false;
        }else{
          this.img_date=file;
          this.openInformation();
        }
        //this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png'];
        const isImage = types.includes(file.type);
        const isLtSize = file.size / 1024 / 1024 < 5;
        if (!isImage) {
        this.$message.error('上传图片只能是 JPG、GIF、BMP、PNG 格式!');
        }
        if (!isLtSize) {
        this.$message.error('上传图片大小不能超过 5MB!');
        }
        return isImage && isLtSize;
      },
      //文本编辑器
      saveDoc(markdown, html) {
        if(this.content.length<=0){
          this.$message({
            message: '请填写内容后再保存',
            type: 'warning'
          });
          return false;
        }
        let admin_id=this.$store.state.a_id;
        this.AddForm_goodsinfor.admin_id=admin_id;
        //this.aboutdata.type="update";
        this.AddForm_goodsinfor.content=markdown;
        this.AddForm_goodsinfor.html=html;
        //console.log(index, row);
        commonAPI('SaveGoodsinfor',this.AddForm_goodsinfor).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){}
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
          })
      },
      imgAdd(name, file) {
        var formdata = new FormData();
        formdata.append('image', file);
        axios({
          url: '/api/AddAboutIMG',
          method: 'post',
          data: formdata,
          headers: { 'Content-Type': 'multipart/form-data' },
        }).then((res) => {
          let url=res.data.data
          this.$refs.md.$img2Url(name, url);
        })
      },
      imgDel(name){
        console.log("name内容:" + name);
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 23%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:24;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 800px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:27;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
   .avatar-uploader .el-upload:hover {
     border-color: #409EFF;
   }
   .avatar-uploader-icon {
     font-size: 28px;
     color: #8c939d;
     width: 178px;
     height: 178px;
     line-height: 178px;
     text-align: center;
   }
   .avatar {
     width: 200px;
     height: 200px;
     display: block;
   }

   .logindivD{
     position: fixed;
     top: 20%;
     left:0;
     right:0;
     bottom: 0;
     margin:0 auto;
     padding: 20px;
     border: 0px solid #ddd;
     z-index:20;
     overflow: auto;
     text-align: center;
     display: none;
   }
   .loginFormD{
     margin: 0 auto;
     width: 550px;
     background-color: #fff;
     -webkit-box-shadow: #333 0px 5px 5px;
     -moz-box-shadow: #333 0px 5px 5px;
     box-shadow: #333 0px 5px 5px;
   }
   .loginFormD a{
     color: #fff;
   }
   .loginFormD a:hover{
     color: #d6d6d6;
   }
   .flex{
     /*flex 布局*/
     display: flex;
     /*实现垂直居中*/
     align-items: center;
     /*实现水平居中*/
     justify-content: center;
     text-align: justify;
   }

   /**商品详情的框架*/
   .Goodsinfordiv{
     position: fixed;
     top: 2%;
     left:0;
     right:0;
     bottom: 0;
     margin:0 auto;
     padding: 20px;
     border: 0px solid #ddd;
     z-index:25;
     overflow: auto;
     display: none;
   }
   .GoodsinforForm{
     margin: 0 auto;
     width: 1200px;
     height: 850px;
     background-color: #fff;
     -webkit-box-shadow: #333 0px 5px 5px;
     -moz-box-shadow: #333 0px 5px 5px;
     box-shadow: #333 0px 5px 5px;
   }
   .GoodsinforForm a{
     color: #fff;
   }
   .GoodsinforForm a:hover{
     color: #d6d6d6;
   }
   .playlistbox_botton1{
      width: 600px;
      margin: 0 auto;
      overflow: hidden;
      height: 426px;
      overflow-y: scroll;
    }
    /**滚动条样式*/
    .playlistbox_botton1::-webkit-scrollbar{
      width: 5px;
    }
    .playlistbox_botton1::-webkit-scrollbar-thumb{
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: #535353;
    }
    .playlistbox_botton1::-webkit-scrollbar-thumb{
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      border-radius: 10px;
      background: #EDEDED;
    }
    /**！Orderinfor框架*/
</style>



// WEBPACK FOOTER //
// src/admin/views/goods/GoodsList.vue